import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for Maps
 * Serialized format is a JSON stringified representation of the object
 *
 * Only supports maps with string keys, as serialization converts them to objects
 */
export const mapSerializer = CreateSerializer(serializeMap, deserializeMap, true);
function serializeMap(value) {
    return Object.fromEntries(value.entries());
}
function deserializeMap(value) {
    return new Map(Object.entries(value));
}
